import { useState } from 'react'
import { View } from 'react-native'
import Page from '@shell/Page'
import ExtraDealModal from '@order/modals/ExtraDealModal'
import ButtonsFixed from '@ui/buttons/ButtonsFixed'
import Button from '@ui/buttons/Button'
import PaymentActionsModal from 'features/payment/modals/PaymentActions/PaymentActionsModal'

export default function DevModalExtraDeal() {
  const [extraDealModal, setExtraDealModal] = useState(false)
  const [paymentModal, setPaymentModal] = useState(false)

  const handleExtraDeal = () => {
    console.log('Accept')
  }

  const handleSkipExtraDeal = () => {
    console.log('Skip')
  }

  return (
    <>
      <Page stage="configuration">
        <View className="flex h-full w-full flex-1 flex-col items-center justify-center gap-8">
          <Button
            variant="filled"
            label="Open Payment Modal"
            onPress={() => setPaymentModal(true)}
          />
          <Button
            variant="filled"
            label="Open Extra Deal Modal"
            onPress={() => setExtraDealModal(true)}
          />
        </View>
      </Page>
      <ExtraDealModal
        title="Claim Your Extra Pair Discount!"
        desc="Get a stylish sun prescription, a fresh look for every outfit, or a backup for emergencies. Completely free choice from all brillen.de collections & packages. Don’t miss out on this one-time offer for your order and configure them now!"
        body="The discount will be calculated based on the total price value of the order (up to 50%) and will be finalized at checkout. Please note that all frames, packages, and optional add-ons are displayed at their standard list prices during the configuration process; your final savings will be reflected once you proceed to checkout."
        // image={}
        open={extraDealModal}
        onSkip={handleSkipExtraDeal}
        onAccept={handleExtraDeal}
        close={() => setExtraDealModal(false)}
      />
      <PaymentActionsModal
        orderIds={['1', '2', '3']}
        open={paymentModal}
        onCheckRefundBalance={() => {
          console.log('Check Refund Balance')
        }}
        close={() => setPaymentModal(false)}
      />
    </>
  )
}
